import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@pearsontechnology/aero-components';
import { trimLongText } from 'utils/trimLongText';
import {
  PluginBox,
  PluginBoxHeader,
  PluginBoxDescription,
  PluginBoxVersion,
  PluginBoxTitle,
} from '../../styles';
import { pluginsToDeactivate } from './pluginsToDeactivate';

const PluginsList = ({ plugins, selectedKey, onPluginSelect }) => (
  plugins
    .filter((pluginObj) => selectedKey ? (selectedKey === pluginObj.category) : true)
    .filter((plugin) => !pluginsToDeactivate.includes(plugin.pluginId))
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    .map(({ name, pluginId, description, latestVersion, type }) => (
      <PluginBox
        key={pluginId}
        onClick={() => onPluginSelect(pluginId, latestVersion, type, name)}
      >
        <PluginBoxHeader>
          <SVGIcon
            icon={'duotonePlugins'}
            viewBox="0 0 24 24"
            primary
          />
          <PluginBoxTitle>{name}</PluginBoxTitle>
        </PluginBoxHeader>
        <PluginBoxDescription>
          {description && trimLongText(description, 65, 2)}
        </PluginBoxDescription>
        <PluginBoxVersion>
          {`v${latestVersion}`}
        </PluginBoxVersion>
      </PluginBox>
    ))
);

PluginsList.propTypes = {
  selectedKey: PropTypes.string,
  onPluginSelect: PropTypes.func,
  plugins: PropTypes.arrayOf(PropTypes.shape({
    pluginId: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    creator: PropTypes.shape({
      accountId: PropTypes.string,
      email: PropTypes.arrayOf(PropTypes.string),
    }),
  })),
};

export default PluginsList;
